import { PackagingTypeEnum } from '../enum/packaging-type.enum';

export class PackagingTypeName {
    static describe(p: string): string {
        switch (p) {
            case PackagingTypeEnum.CUSTOMER_PACKAGING:
                return `Customer Packaging`;
            case PackagingTypeEnum.BOX:
                return `Box`;
            case PackagingTypeEnum.ENVELOPE:
                return `Envelope`;
            case PackagingTypeEnum.PAK:
                return `Pak`;
            case PackagingTypeEnum.FEDEX_10KG_BOX:
                return `10kg Box`;
            case PackagingTypeEnum.FEDEX_25KG_BOX:
                return `25kg Box`;
            case PackagingTypeEnum.PALLET:
                return `Non-Stackable Pallet`;
            case PackagingTypeEnum.STACKABLE_PALLET:
                return `Stackable Pallet`;
            default:
                return `Customer Packaging`;
        }
    }
}
